import * as o from "react";
import s from "../lib/IconBase.es.js";
import n from "../defs/Question.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...t, weights: n }));
e.displayName = "QuestionIcon";
const m = e;
export {
  m as Question,
  e as QuestionIcon
};
